import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  regularisationApprovalList,
  updateRegularisationApproval,
} from "../../store/AttendanceSlice/thunk";
import { attendanceActions } from "../../store/AttendanceSlice";
import NothingIcon from "../../assets/images/task-not-found-1 6.png";
import BackIcon from "../../assets/icons/arrow_back.svg";
import TickIcon from "../../assets/icons/done_all_white.svg";
import CloseIcon from "../../assets/icons/close-2hite.svg";
import LoginIcon from "../../assets/icons/login.svg";
import LogoutIcon from "../../assets/icons/logout.svg";
import SuccessImg from "../../assets/images/success.png";
import CommonModal from "../../commonComponents/CommonModal";
import moment from "moment";
import "./RegularisationApproval.css";
import { getAllReportees } from "../../store/RequestSlice/thunk";
import InitialsCircle from "../InitialsCircle";
import CustomCalendar from "../../commonComponents/CustomCalendar";
import CustomPagination from "../../commonComponents/CustomPagination";
import { ApprovalCardSkeletons, ReporteeSkeleton } from "../../utils/skeleton";

const RemarksPopUp = ({
  regularisationSelected,
  setRegularisationSelected,
  onUpdateApprovals,
  closeremarksRef,
  updateRegularisationApprovalResponseStatus,
}) => {
  return (
    <div className="flex flex-col rp-rm-pop">
      <div className="rm-rp-head">Please enter remarks before submit</div>

      <textarea
        autoFocus
        className="rm-rp-input"
        placeholder="Remarks for rejection"
        value={regularisationSelected?.remarks || ""}
        onChange={(e) =>
          setRegularisationSelected((prev) => ({
            ...prev,
            remarks: e.target.value,
          }))
        }
      />

      <div className="flex items-center mt-3 justify-center w-full">
        <div
          className="rp-approval-card-action-btn rp-reject"
          onClick={() => {
            onUpdateApprovals();
            closeremarksRef?.current?.click();
          }}
        >
          {updateRegularisationApprovalResponseStatus === "PENDING"
            ? "Submitting..."
            : "Submit"}
        </div>
      </div>
    </div>
  );
};

const RegularisationApproval = ({ changeStatus }) => {
  const dispatch = useDispatch();

  const employeeID = useSelector((state) => state.auth.employeeID);

  const role = useSelector(
    (state) => state?.auth?.loginResponse?.body?.role_type || "",
  );

  const regularisationApprovalListResponse = useSelector(
    (state) => state?.attendance?.regularisationApprovalListResponse || [],
  );
  const regularisationApprovalListResponseStatus = useSelector(
    (state) =>
      state?.attendance?.regularisationApprovalListResponseStatus || [],
  );

  const updateRegularisationApprovalResponseStatus = useSelector(
    (state) =>
      state?.attendance?.updateRegularisationApprovalResponseStatus || [],
  );

  const getAllReporteesResponse = useSelector(
    (state) => state.request.getAllReporteesResponse,
  );
  const getAllReporteesResponseStatus = useSelector(
    (state) => state.request.getAllReporteesResponseStatus,
  );
  const openremarksRef = useRef();
  const closeremarksRef = useRef();
  const openSuccessRef = useRef();
  const closeSuccessRef = useRef();
  const dropdownRef = useRef();

  const [regularisationSelected, setRegularisationSelected] = useState({});
  const [showDropdown, setShowDropdown] = useState(false);
  const [search, setSearch] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [filteredApprovalList, setFilteredApprovallist] = useState([]);
  console.log("list", filteredApprovalList);
  const [reporteeList, setReporteeList] = useState(
    getAllReporteesResponse?.reportees,
  );
  const [dateRangeSelected, setDateRangeSelected] = useState({
    startDate: new Date(),
    endDate: new Date(),
  });
  const [page, setPage] = useState(1);

  const LIMIT = 2000;

  useEffect(() => {
    dispatch(getAllReportees({ offset: 0, limit: LIMIT }));

    return () => {
      dispatch(attendanceActions.resetRegularisationApprovals());
    };
  }, []);

  useEffect(() => {
    if (regularisationApprovalListResponse?.body?.file_url) {
      window.open(regularisationApprovalListResponse?.body?.file_url);
    } else if (Array.isArray(regularisationApprovalListResponse?.body)) {
      setFilteredApprovallist(regularisationApprovalListResponse?.body || []);
    }
  }, [regularisationApprovalListResponse]);

  useEffect(() => {
    if (dateRangeSelected?.startDate && dateRangeSelected?.endDate) {
      getregularisationApprovalList();
    }
  }, [dateRangeSelected, page]);

  useEffect(() => {
    if (selectedEmployee) {
      const index = reporteeList.findIndex((r) => r.full_name === search);
      if (index !== -1 && reporteeList.length > 2) {
        const updatedList = [...reporteeList];

        const [matchedItem] = updatedList.splice(index, 1);

        updatedList.splice(2, 0, matchedItem);

        setReporteeList(updatedList);
      }
      console.log("selectedEmployee", selectedEmployee);
      const updatedApprovalList =
        filteredApprovalList?.length &&
        filteredApprovalList?.filter(
          (item) =>
            String(item?.full_name) === String(selectedEmployee?.full_name),
        );
      console.log("updatedApprovalList", updatedApprovalList);
      setFilteredApprovallist(updatedApprovalList);
    } else {
      setFilteredApprovallist(regularisationApprovalListResponse?.body);
    }
  }, [selectedEmployee, search]);

  useEffect(() => {
    if (updateRegularisationApprovalResponseStatus === "SUCCESS") {
      setRegularisationSelected({});
      if (closeremarksRef.current) {
        // closeremarksRef.current.click();
      }
      openSuccessRef.current.click();
      getregularisationApprovalList();
    }
  }, [updateRegularisationApprovalResponseStatus]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const getregularisationApprovalList = (file = false) => {
    dispatch(
      regularisationApprovalList({
        employee_id: employeeID,
        start_date:
          moment(dateRangeSelected?.startDate).format("DD-MM-YY") || "",
        end_date: moment(dateRangeSelected?.endDate).format("DD-MM-YY") || "",
        length: "10",
        start: String((page - 1) * 10),
        file: file,
        role: role,
      }),
    );
  };

  const onUpdateStatus = (data) => {
    setRegularisationSelected(data);

    if (data?.status === "rejected") {
      openremarksRef.current.click();
    } else {
      onUpdateApprovals(data);
    }
  };

  const onUpdateApprovals = (data = {}) => {
    const payloadData = data?.date ? data : regularisationSelected;

    const payload = {
      employee_id: payloadData?.employee_id,
      date: moment(new Date(payloadData?.date)).format("DD-MM-YYYY"),
      status: payloadData?.status,
      remarks: payloadData?.remarks || "",
    };
    // console.log("update payload: ", payload);
    dispatch(updateRegularisationApproval(payload));
  };

  const SuccessPopup = () => (
    <div className="att-succ-pop">
      <img className="att-succ-img" src={SuccessImg} alt="" />
      <div className="att-succ-text">“Regularisation approval success”</div>
      {/* <div className="att-succ-subtext">
        Your regularisation approval success.
      </div> */}
    </div>
  );

  return (
    <div className="regularisation-approval">
      <div className="rp-head">
        <div className="rp-head-left">
          <div className="rp-back-wrap" onClick={changeStatus}>
            <img src={BackIcon} alt="Back" className="rp-back-img" />
          </div>

          <div className="rp-header">regularisation approvals</div>
        </div>

        <div className="flex items-center">
          <div
            className={`rp-download-btn ${!filteredApprovalList?.length && "disabled"}`}
            onClick={() => {
              if (filteredApprovalList?.length) {
                getregularisationApprovalList(true);
              }
            }}
          >
            <span
              style={{ fontSize: "16px", color: "black" }}
              className="material-symbols-rounded"
            >
              download
            </span>
            <div className="rp-download-btn-text">Download Report</div>
          </div>
          <CustomCalendar
            onSelectDate={(value) => {
              setDateRangeSelected(value);
              setPage(1);
            }}
          />
          {getAllReporteesResponseStatus === "PENDING" && <ReporteeSkeleton />}
          {getAllReporteesResponseStatus === "SUCCESS" && (
            <div
              className="rp-avatar-group rp-reportee"
              onClick={() => setShowDropdown(!showDropdown)}
            >
              {reporteeList?.map((reportee, index) => {
                const isSelected =
                  search && reportee.full_name === search && index === 0;
                return (
                  index < 3 && (
                    <div
                      key={reportee.employee_id || index}
                      className="rp-avatar"
                      style={{
                        // border: "none",
                        border: isSelected ? "2px solid #253037" : "none",
                        borderRadius: "12px",
                        height: "36px",
                        width: "36px",
                      }}
                    >
                      <InitialsCircle
                        fullName={reportee.full_name}
                        size={36}
                        borderRadius="12px"
                      />
                    </div>
                  )
                );
              })}
              {reporteeList?.length === 0 && (
                <>
                  <div className="rp-avatar" />
                  <div className="rp-avatar" />
                  <div className="rp-avatar" />
                </>
              )}
              <div className="rp-avatar-arrow-wrap">
                <span className="rp-avatar-arrow">▾</span>
              </div>
            </div>
          )}
        </div>
        {showDropdown && (
          <div className="rp-dropdown-popup" ref={dropdownRef}>
            <div style={{ position: "relative", width: "100%" }}>
              <input
                className="rp-search-input"
                style={{
                  width: "100%",
                  paddingRight: "30px",
                  boxSizing: "border-box",
                }}
                placeholder="Search reportees"
                value={search}
                onChange={(e) => {
                  setSearch(e.target.value);
                  if (!e.target.value) {
                    setSelectedEmployee(null);
                    setShowDropdown(false);
                  }
                }}
              />
              {search && (
                <span
                  style={{
                    position: "absolute",
                    right: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                    fontSize: "14px",
                    color: "#999",
                    lineHeight: 1,
                  }}
                  onClick={() => {
                    setSearch("");
                    setSelectedEmployee(null);
                  }}
                >
                  ✕
                </span>
              )}
            </div>
            <div className="drop-users">
              {(reporteeList || []).map((m, i) => {
                const isSelected =
                  selectedEmployee?.employee_id === m.employee_id;
                return (
                  <div
                    key={i}
                    className="rp-dropdown-item"
                    style={{
                      cursor: "pointer",
                      backgroundColor: isSelected ? "#FFF8E1" : "transparent",
                    }}
                    onClick={() => {
                      setSearch(m.full_name);
                      setSelectedEmployee(m);
                      setShowDropdown(false);
                    }}
                  >
                    <InitialsCircle size={16} fullName={m.full_name} />
                    <div className="rp-avatar-text">{m.full_name}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}
      </div>
      {regularisationApprovalListResponseStatus === "PENDING" && (
        <ApprovalCardSkeletons />
      )}
      {regularisationApprovalListResponseStatus === "SUCCESS" && (
        <>
          <div className="rp-scroll-content w-full">
            {!filteredApprovalList?.length && (
              <div className="rp-empty">
                <img className="rp-empty-ico" src={NothingIcon} alt="" />
                <div className="rp-empty-text">“there’s nothing here”</div>
                <div className="rp-empty-subtext">
                  You’ve not taken any leaves yet.
                </div>
              </div>
            )}
            <div className="rp-approval-list">
              {(filteredApprovalList?.length &&
                filteredApprovalList?.map((approval, index) => (
                  <div className="rp-approval-card" key={index}>
                    <div className="rp-approval-card-header">
                      {/* <img
                    className="rp-approval-avatar-ico"
                    src={Avatar1Icon}
                    alt=""
                  /> */}
                      <InitialsCircle
                        fullName={approval?.full_name}
                        size={40}
                        borderRadius="8px"
                      />

                      <div className="rp-approval-card-name">
                        {approval?.full_name}
                      </div>

                      <div className="rp-approval-card-id">
                        ID #{approval.employee_id}
                      </div>
                    </div>

                    <div className="rp-approval-card-body">
                      <div className="rh-hs-item-left">
                        <div className="rh-hs-range">
                          <div className="rh-hs-start-wrap">
                            <img
                              src={LoginIcon}
                              alt=""
                              className="rh-log-ico"
                            />

                            <div className="rh-hs-start-text">
                              {`${moment(approval?.date).format("DD MMM'YY")} at ${moment(
                                approval?.clock_in,
                                "HH:mm:ss",
                              ).format("hh:mm A")}`}
                            </div>
                          </div>

                          <div className="rh-hs-end-wrap">
                            <img
                              src={LogoutIcon}
                              alt=""
                              className="rh-log-ico"
                            />

                            <div className="rh-hs-end-text">
                              {`${moment(approval?.clock_out_date).format(
                                "DD MMM'YY",
                              )} at ${moment(
                                approval?.clock_out,
                                "HH:mm:ss",
                              ).format("hh:mm A")}`}
                            </div>
                          </div>
                        </div>
                      </div>

                      {approval.reason && (
                        <div className="rp-approval-card-reason-wrap">
                          <div
                            className={`rp-approval-attach-wrap ${!approval?.s3_url && "disabled"}`}
                            onClick={() => {
                              if (approval?.s3_url) {
                                window.open(approval?.s3_url, "_blank");
                              }
                            }}
                          >
                            <span
                              style={{ fontSize: "40px", color: "black" }}
                              className="material-symbols-rounded"
                            >
                              docs
                            </span>
                          </div>

                          <div className="rp-approval-card-reason-text-wrap">
                            <div className="rp-approval-card-reason-text">
                              {approval.reason === "Others" ? (
                                <div className="flex items-center">
                                  <div className="rp-approval-card-reason-text other">
                                    Others
                                  </div>

                                  <div className="rp-approval-card-reason-text other-sub">
                                    &nbsp;&nbsp;|&nbsp;&nbsp;
                                    {approval?.employee_comment}
                                  </div>
                                </div>
                              ) : (
                                <div className="rp-approval-card-reason-text default">
                                  {approval?.reason}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}

                      <div className="rp-approval-card-actions">
                        <div className="flex">
                          <div
                            className="rp-approval-card-action-btn rp-approve"
                            onClick={() =>
                              onUpdateStatus({
                                ...approval,
                                status: "approved",
                              })
                            }
                          >
                            <img
                              src={TickIcon}
                              className="rp-approval-card-ico"
                              alt=""
                            />
                            {updateRegularisationApprovalResponseStatus ===
                              "PENDING" &&
                            regularisationSelected?.employee_id ===
                              approval.employee_id
                              ? "Approving..."
                              : "Approve"}
                          </div>

                          <div
                            className="rp-approval-card-action-btn rp-reject"
                            onClick={() =>
                              onUpdateStatus({
                                ...approval,
                                status: "rejected",
                              })
                            }
                          >
                            <img
                              src={CloseIcon}
                              className="rp-approval-card-ico"
                              alt=""
                            />
                            Reject
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))) ||
                ""}
            </div>
          </div>

          <div className="rp-pagination">
            {(filteredApprovalList?.length && (
              <CustomPagination
                totalCount={
                  regularisationApprovalListResponse?.total_count || 0
                }
                itemsPerPage={10}
                currentPage={page}
                onPageChange={setPage}
              />
            )) ||
              ""}
          </div>
        </>
      )}

      <CommonModal
        openRef={openremarksRef}
        closeRef={closeremarksRef}
        id="remarkpopup"
        outSideCloseButton={true}
        hideCloseButton={true}
        content={
          <RemarksPopUp
            regularisationSelected={regularisationSelected}
            setRegularisationSelected={setRegularisationSelected}
            onUpdateApprovals={onUpdateApprovals}
            closeremarksRef={closeremarksRef}
            updateRegularisationApprovalResponseStatus={
              updateRegularisationApprovalResponseStatus
            }
          />
        }
        disabled={false}
        size="sm"
        // backDrop={false}
        modalStyle={{
          borderRadius: "24px",
          background: "#FFF",
          boxShadow: "0 4px 40px rgba(23,33,40,0.10)",
          minHeight: "96px",
          minWidth: "428px",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />

      <CommonModal
        openRef={openSuccessRef}
        closeRef={closeSuccessRef}
        id="sucesspopup"
        outSideCloseButton={true}
        hideCloseButton={true}
        content={<SuccessPopup />}
        disabled={false}
        size="sm"
        // backDrop={false}
        modalStyle={{
          borderRadius: "24px",
          background: "#FFF",
          boxShadow: "0 4px 40px rgba(23,33,40,0.10)",
          minHeight: "96px",
          minWidth: "428px",
        }}
        modalBodyStyle={{
          padding: "0px",
        }}
      />
    </div>
  );
};

export default RegularisationApproval;
